import React from 'react'
import PropTypes from 'prop-types'
import {
  CloseButton,
  ModalBodyCopy,
  ContainedButton,
  BackpackSuccess as SuccessIcon,
} from 'secondstep-components'
import {
  ButtonsWrapperSuccess,
  SuccessModalWrapper,
  Header,
  SubHeader,
} from './component.styles'
import { toUrlSafe } from 'utils/stringHelpers'
import {
  HEADER_SUCCESS,
  BODY_TYPE_PREFIX_CLASS,
  BODY_TEXT_CREATE,
  BODY_TEXT_EDIT,
  BUTTON_SUBMIT,
  MAX_CLASSES_REACHED,
} from './constants'

const propTypes = {
  currentSite: PropTypes.shape({
    siteId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    siteName: PropTypes.string,
    isSetup: PropTypes.bool,
  }),
  dataTestId: PropTypes.string,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  maxClassesReached: PropTypes.bool,
  successFor: PropTypes.string,
  title: PropTypes.string.isRequired,
}

const Success = ({
  currentSite,
  dataTestId,
  handleClose,
  handleSubmit,
  maxClassesReached,
  successFor,
  title,
}) => {
  const edit = successFor === 'Edit'
  const modalSize = edit ? 'small' : null
  const bodyText = edit ? BODY_TEXT_EDIT : BODY_TEXT_CREATE

  // Create a custom click handler that adds the site query parameter
  const handleSubmitWithSiteParam = () => {
    if (currentSite?.siteId && handleSubmit) {
      // If we have a currentSite and it's not the edit flow, modify the URL
      if (successFor !== 'Edit') {
        // Get the current URL and add the site parameter
        const currentUrl = window.location.href
        const url = new URL(currentUrl)
        url.searchParams.set('site', currentSite.siteId)
        // Update the URL without triggering a page reload
        window.history.replaceState({}, '', url.toString())
      }
    }
    // Call the original handleSubmit function
    if (handleSubmit) {
      handleSubmit()
    }
  }
  return (
    <SuccessModalWrapper dataTestId={dataTestId} size={modalSize}>
      <CloseButton dataTestId="button-close" onClick={handleClose} />
      <SuccessIcon dataTestId="icon-success" />
      <Header dataTestId="modal-success-header">{HEADER_SUCCESS}</Header>
      <SubHeader data-testid="modal-success-subheader">
        {`${bodyText} ${title} ${BODY_TYPE_PREFIX_CLASS}`}
      </SubHeader>
      {maxClassesReached && (
        <ModalBodyCopy data-testid="modal-success-max-classes-reached">
          {MAX_CLASSES_REACHED}
        </ModalBodyCopy>
      )}
      <ButtonsWrapperSuccess>
        <ContainedButton
          dataTestId={`button-${toUrlSafe(BUTTON_SUBMIT)}`}
          onClick={handleSubmitWithSiteParam}
        >
          {BUTTON_SUBMIT}
        </ContainedButton>
      </ButtonsWrapperSuccess>
    </SuccessModalWrapper>
  )
}

Success.propTypes = propTypes

export default Success
